export function faviconUrlFromWebsite(website) {
    if (!website) return '';
    return website.faviconFinal || website.logoFinal || '';
}

export function faviconMimeFromUrl(url) {
    const path = String(url || '').split('?')[0].split('#')[0].toLowerCase();
    if (path.endsWith('.png')) return 'image/png';
    if (path.endsWith('.svg')) return 'image/svg+xml';
    if (path.endsWith('.webp')) return 'image/webp';
    if (path.endsWith('.jpg') || path.endsWith('.jpeg')) return 'image/jpeg';
    if (path.endsWith('.gif')) return 'image/gif';
    return 'image/x-icon';
}

export function applyWebsiteFavicon(website) {
    if (typeof document === 'undefined') return;
    const href = faviconUrlFromWebsite(website);
    if (!href) return;

    document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach((node) => {
        node.parentNode?.removeChild(node);
    });

    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = faviconMimeFromUrl(href);
    link.href = href;
    document.head.appendChild(link);

    if (website.title) {
        document.title = website.title;
    }
}
